export const ROUTES = {
  dashboard: "/",
  prediction: "/prediction",
  recommendation: "/recommendation",
  balance: "/balance",
  login: "/login",
  predictionHistory: "/prediction-history",
  recommendationHistory: "/recommendation-history",
  balanceHistory: "/balance-history",
  help: "/help",
};
